// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2KtDN","dragIcon":"Choice_dragIcon__I_WLi","left":"Choice_left__2Hlr5","input":"Choice_input__3Wn3G"};